export const ReportOrderBy = Object.freeze({
  PERSON: 'Nome da Pessoa',
  DATE: 'Data de emissão'
});